import { graphql } from '@/generated/gql';

export const NEGOTIATED_QUOTE_DECLINE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiatedQuoteDecline($negotiationCaseId: UUID!, $data: TsrctNegotiatedQuoteActionInput!) {
    tesseract {
      negotiationCase(id: $negotiationCaseId) {
        negotiatedQuote {
          draftDecline(data: $data) {
            id
          }
        }
      }
    }
  }
`);
